import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cems',
  templateUrl: './cems.component.html',
  styleUrls: ['./cems.component.css']
})
export class CemsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
